import {
    Button,
    Checkbox,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid
} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {SmoothActionBar} from "../../../misc/SmoothActionBar";
import {useFilePicker} from "../shopdrawing/extras/FilePicker";
import {useSyncedRef} from "../../../misc/SyncedRef";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../api/API";
import {ext} from "../../../api/Files";
import React, {useState} from "react";
import useWindowSize from "react-use/lib/useWindowSize";

export function LiteKitPopup(props: {
    entityName: string;
    file?: number;
    name?: string;
    showCreateGlobalOpt?: boolean;
    onCancel(): void;
    onDone(input: {file?: number, createGlobal: boolean}): Promise<any>;
}) {
    const filePicker = useFilePicker({
        accept: ["application/pdf", "image/*"],
    });

    const onDoneRef = useSyncedRef(props.onDone);
    const [file, setFile] = useState(props.file);

    const upload = useAsyncAction(async (file: File) => {
        const fileObj = await api.files.upload({
            file: file,
            // use guid naming to prevent collisions
            name: window.crypto.randomUUID() + ext(file.name),
            convert2pdf: true,
        });

        setFile(fileObj.id);
    }, []);

    const size = useWindowSize();
    const update = useAsyncAction(async (opts: {file?: number, createGlobal: boolean}) => {
        await onDoneRef.current(opts);
    }, []);

    const [createGlobal, setCreateGlobal] = useState(false);

    const submit = () => {
        update.callback({
            file,
            createGlobal: createGlobal,
        })
    };

    return (
        <Dialog2 open onClose={props.onCancel} onEnterPress={submit} fullWidth maxWidth="xl">
            <DialogTitle>
                Lite Kit Profile for {props.entityName}
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}}/>
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        {file ? <iframe
                            src={api.files.downloadLink(file, "inline")}
                            style={{
                                height: size.height * 0.75,
                                width: "100%",
                                border: "1px solid black",
                            }}
                        ></iframe> : <div>Choose a file on the right</div>}
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{display: "flex"}}>
                            <Button variant="outlined" fullWidth onClick={async () => {
                                const files = await filePicker();
                                upload.callback(files[0])
                            }}>Upload</Button>
                            {upload.LoadingElement}
                        </div>
                        <div style={{height: 8}} />
                        <Button variant="outlined" disabled={!file} fullWidth onClick={() => {
                            setFile(undefined);
                        }}>Clear</Button>

                        <div style={{height: 8}} />

                        {props.showCreateGlobalOpt && <div style={{paddingLeft: 4, paddingRight: 4}}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small" checked={createGlobal}
                                        onClick={(e) => setCreateGlobal(!createGlobal)}
                                    />
                                }
                                label="Create as Global Lite Kit Profile"
                            />
                        </div>}
                    </Grid>
                </Grid>
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                actionName="Update"
                onCancel={() => props.onCancel()}
                onSubmit={submit}
            />
        </Dialog2>
    )
}